<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="cpt-header-container">
      <SearchBar></SearchBar>
      <MainMenu></MainMenu>
      <SideBar></SideBar>
    </div>
  </div>
</template>

<script>
import '@/styles/components/header/header.scss';
import SearchBar from '@/components/header/SearchBar';
import MainMenu from '@/components/header/MainMenu';
import SideBar from '@/components/header/SideBar';
const prefix = 'cpt-head-header';

export default {
  name: 'Header',
  components: {
    SearchBar,
    MainMenu,
    SideBar
  },
  props: {
    searchKeyword: String
  },
  data () {
    return {
      prefix
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue